<template>
	<div class="promo__list">
		<h2 class="promo__list__title">Your Offers</h2>
		<empty
			v-if="promos.length == 0"
			:message="'There are no offers at the moment.'"
			:background="true"
			:icon="true"
		/>

		<div v-for="(cat, idx) in promos" :key="idx" class="promo__list__category">
			<list-item
				v-for="(promo, idxPromo) in cat.promoData"
				:key="idxPromo"
				:promo="promo"
			/>
		</div>
	</div>
</template>
<script>
import Empty from "../../Shared/Empty.vue";
import ListItem from "./ListItem.vue";

export default {
	name: "offers-list",
	components: {
		Empty,
		ListItem,
	},
	mounted() {
		let vm = this;
		vm.$store.dispatch("promos/getPromos");
	},
	computed: {
		promos() {
			return this.$store.getters["promos/list"];
		},
	},
};
</script>
<style lang="scss">
.offers {
	padding: 15px;
	padding-top: var(--base-padding-edges);
	padding-bottom: var(--base-padding-edges);
	background: var(--white);

	.promo {
		&__list {
			&__title {
				font-size: var(--font-large);
				font-weight: var(--font-weight-normal);
				margin-top: 20px;
			}
			&__rewards,
			&__offers {
				&__header,
				&__footer {
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: space-between;
				}

				&__header {
					&--status {
						font-size: var(--font-small);
						font-weight: var(--font-weight-lighter);
						text-align: right;
						margin-left: 15px;
					}
				}
				&__footer {
					margin-top: 15px;

					a,
					button {
						background: none;
						padding: 0;
						margin: 0;
						color: var(--green);
						text-decoration: none;
						font-size: var(--font-medium);
						font-weight: var(--font-weight-lighter);
					}
				}

				&__body {
					font-size: var(--font-small);
					margin: 20px 0;

					&--description {
						margin-top: 0;
						margin-bottom: 8px;
					}
					&--time {
						font-weight: var(--font-weight-lighter);
						color: var(--light-dark-blue);
					}
				}
			}
			&__category {
				display: grid;
				flex-wrap: wrap;
				grid-template-columns: repeat(1, 1fr);
				grid-gap: 20px;
				@media (min-width: 1023px) {
					grid-template-columns: repeat(2, 1fr);
				}
			}
		}
	}
}
</style>
